import type { Swiper as SwiperInstance } from 'swiper'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import MainButton from '../../ui/MainButton/MainButton'
import ProductItem from '../../ui/ProductItem/ProductItem'

import { useEffect, useRef } from 'react'
import { Product } from '../../../types/product'
import s from './SliderProducts.module.css'

const SliderProducts = ({
  category,
  title,
  buttonText,
  products,
  slug,
}: {
  category: string
  title?: string
  buttonText?: string
  products: Product[]
  slug?: string
}) => {
  const prevRef = useRef<HTMLButtonElement | null>(null)
  const nextRef = useRef<HTMLButtonElement | null>(null)
  const swiperRef = useRef<SwiperInstance | null>(null)
  const progressBarFillRef = useRef<HTMLDivElement | null>(null)
  const isMobile = window.innerWidth < 1024

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.navigation.init()
      swiperRef.current.navigation.update()
    }
  }, [products])

  return (
    <div className={s.sliderProducts}>
      <div className={s.heroSlider}>
        <h2>
          {title ||
            (category === 'new'
              ? 'Поповнення в seaters'
              : category === 'related'
              ? 'Також рекомендуємо'
              : category === 'kava'
              ? 'Кава'
              : category === 'dripi'
              ? 'Дріпи'
              : category === 'kapsuli'
              ? 'Капсули'
              : 'Популярні товари')}
        </h2>
        {!isMobile && buttonText && slug && <MainButton text={buttonText} href={`/${slug}`} />}
      </div>
      <Swiper
        id={category}
        spaceBetween={16}
        slidesPerView={1.05}
        loop={products.length > 3}
        modules={[Navigation]}
        navigation={{
          prevEl: prevRef.current!,
          nextEl: nextRef.current!,
        }}
        onSwiper={(swiper: SwiperInstance) => {
          swiperRef.current = swiper
        }}
        breakpoints={{
          1024: {
            slidesPerView: 3,
            spaceBetween: 28,
          },
        }}
        onSlideChange={(swiper: SwiperInstance) => {
          if (progressBarFillRef.current) {
            const step = 100 / Math.max(products.length, 1)
            progressBarFillRef.current.style.width = `${(swiper.realIndex + 1) * step}%`
          }
        }}
      >
        {products.map(product => (
          <SwiperSlide key={product.id}>
            <ProductItem product={product} />
          </SwiperSlide>
        ))}
        {!isMobile && (
          <div className={s.navigationWrap}>
            <button
              ref={prevRef}
              className={`swiper-prev ${s.swiperNavBtn}`}
              aria-label="Попередні товари"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                <path
                  d="M9.02734 17.2222V17.2222C9.02734 13.2335 5.79384 10 1.80512 10L-0.000433845 10"
                  stroke="#0D0D0D"
                  strokeWidth="2"
                  strokeLinejoin="bevel"
                />
                <path
                  d="M9.02734 2.77777V2.77777C9.02734 6.7665 5.79384 9.99999 1.80512 9.99999L-0.000434476 9.99999"
                  stroke="#0D0D0D"
                  strokeWidth="2"
                  strokeLinejoin="bevel"
                />
                <path d="M1.54972e-06 10L20 10" stroke="#0D0D0D" strokeWidth="2" />
              </svg>
            </button>
            <button
              ref={nextRef}
              className={`swiper-next ${s.swiperNavBtn}`}
              aria-label="Наступні товари"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10.9727 17.2222V17.2222C10.9727 13.2335 14.2062 10 18.1949 10L20.0004 10"
                  stroke="#0D0D0D"
                  strokeWidth="2"
                  strokeLinejoin="bevel"
                />
                <path
                  d="M10.9727 2.77777V2.77777C10.9727 6.7665 14.2062 9.99999 18.1949 9.99999L20.0004 9.99999"
                  stroke="#0D0D0D"
                  strokeWidth="2"
                  strokeLinejoin="bevel"
                />
                <path d="M20 10L0 10" stroke="#0D0D0D" strokeWidth="2" />
              </svg>
            </button>
          </div>
        )}
        {isMobile && (
          <div className={s.progressWrap}>
            <div className={s.progressBar}>
              <div
                ref={progressBarFillRef}
                className={s.progressBarFill}
                style={{ width: `${100 / Math.max(products.length, 1)}%` }}
              ></div>
            </div>
          </div>
        )}
      </Swiper>
      {isMobile && buttonText && slug && <MainButton text={buttonText} href={`/${slug}`} />}
    </div>
  )
}

export default SliderProducts
